var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#FFCB00","strokeWidth":"2","d":"M2.74 12c0-3.771 0-5.657 1.172-6.828C5.083 4 6.969 4 10.74 4h4c3.772 0 5.657 0 6.829 1.172C22.74 6.343 22.74 8.229 22.74 12c0 3.771 0 5.657-1.171 6.828C20.397 20 18.512 20 14.74 20h-4c-3.771 0-5.657 0-6.828-1.172C2.74 17.657 2.74 15.771 2.74 12Z","key":0}),React.createElement("path",{"stroke":"#FFCB00","strokeLinecap":"round","strokeWidth":"2","d":"M6.74 8 8.9 9.8c1.836 1.53 2.754 2.295 3.84 2.295 1.086 0 2.005-.765 3.841-2.296L18.741 8","key":1})]);
}

Email.defaultProps = {"width":"25","height":"24","fill":"none"};

module.exports = Email;

Email.default = Email;
